/* eslint-disable */

import axios from "axios";

const url = require("../../client_config/config").url;

const state = {
  item: [],
  latestTransactions: [],
  monthlyAmountDialog: null,
  financeDialog: null,
  isLoading: false,
  downloadProgressValue: 0,
};

const getters = {
  isLoading: (state) => state.isLoading,
  financeTransaction: (state) => state.item,
  getLatestTransactions: (state) => state.latestTransactions,
};

const actions = {
  async getFinanceTransactions({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(
        `${url}/financeTransactions/${data.financeID}/${data.transactionMethods}`
      );

      //CONVERT 2 DECIMAL PLACES
      response.data.data.forEach((element, index) => {
        var num = parseFloat(element.runningTotal.$numberDecimal);
        response.data.data[index].roundRunningTotal = num.toFixed(2);
      });

      commit("SET_LOADING", false);
      commit("SET_FINANCES_TRANSACTION", response.data.data);
      return response.data.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async getFinanceLatestTransactions({ commit }, clientID) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(
        `${url}/financeTransactions/latest/${clientID}`
      );
      commit("SET_LATEST_TRANSACTION", response.data.data);
      commit("SET_LOADING", false);
      return response.data.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async addFinanceTransaction({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.post(
        `${url}/financeTransactions/transaction`,
        data
      );
      console.log(response);
      // commit("ADD_FINANCE_TRANSACTION", response.data);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  async addFinanceRolloverTransaction({ commit }, {data, id}) {
    commit("SET_LOADING", true);
    console.log(data)
    try {
      const response = await axios.post(
        `${url}/financeTransactions/rollover/${id}`,
        data
      );
      console.log(response);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  async updateFinanceTransaction({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.put(
        `${url}/financeTransactions/update/${data.id}`,
        data.req_body
      );
      // commit("UPDATE_FINANCE_TRANSACTION", response.data.finance);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  async deleteFinanceTransaction({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.delete(`${url}/financeTransactions/${id}`);
      commit("DELETE_FINANCE_TRANSACTION", id);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  async downloadReport({ commit, state }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(
        `${url}/financeTransactions/download/${data.financeID}/${data.transactionMethods}`, 
        {
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'application/pdf'
          },
          onDownloadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            
            if (percentCompleted > state.downloadProgressValue) {
              commit("SET_DOWNLOAD_PROGRESS_VALUE", percentCompleted);
            }
          }
        }
      );

      // //CONVERT 2 DECIMAL PLACES
      // response.data.data.forEach((element, index) => {
      //   let dt = new Date(element.Date);
      //   var num = parseFloat(element.runningTotal.$numberDecimal);
      //   response.data.data[index].roundRunningTotal = num.toFixed(2);
      //   response.data.data[index].Date = dt.toISOString().substring(0, 10);
      // });

      return response;
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  SET_FINANCES_TRANSACTION(state, data) {
    state.item = [];
    data.map((item) => {
      let dt = new Date(item.Date);
      item.Date = dt.toISOString().substring(0, 10);
      state.item.push(item);
    });
  },

  // UPDATE_FINANCE_TRANSACTION(state, data) {
  //   state.financeTransactions.splice(
  //     state.financeTransactions.findIndex(
  //       (finance) => finance._id === data._id
  //     ),
  //     1,
  //     { ...data, Date: moment(new Date(data.Date)).format("MM-DD-YYYY") }
  //   );
  // },

  DELETE_FINANCE_TRANSACTION(state, id) {
    state.item.splice(
      state.item.findIndex((finance) => finance._id === id),
      1
    );
  },

  SET_LATEST_TRANSACTION(state, data) {
    state.latestTransactions = data;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },

  SET_FINANCE_DIALOG(state, data) {
    state.financeDialog = data;
  },

  SET_DOWNLOAD_PROGRESS_VALUE (state, data) {
    state.downloadProgressValue = data
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
